<button nz-button nzType="link"  [nzTooltipTitle]="'Common.Edit' | translate" nz-tooltip  nzTooltipPlacement="topLeft">
    <span>{{'Common.Edit' | translate}}</span>
</button>